import React from 'react'
import { ZinSelect, ZinSelectOption } from '@tnl/zin-react'
import './CompareOptions.scss'

export interface CompareOption {
  value: string
  label: string
}

export interface CompareOptionsProps {
  leftOptions: CompareOption[]
  rightOptions: CompareOption[]
  selectedLeftKey: string
  selectedRightKey: string
  onLeftChange: (e: CustomEvent) => void
  onRightChange: (e: CustomEvent) => void
}

export const CompareOptions: React.FC<CompareOptionsProps> = ({ leftOptions, rightOptions, selectedLeftKey, selectedRightKey, onLeftChange, onRightChange }) => (
  <div className="compare-options">
    <ZinSelect
      className="compare-options__select"
      value={selectedLeftKey}
      onValueChange={onLeftChange}
      noValidate>
      {leftOptions.map((opt) => (
        <ZinSelectOption
          key={opt.value}
          value={opt.value}>
          {opt.label}
        </ZinSelectOption>
      ))}
    </ZinSelect>
    <ZinSelect
      className="compare-options__select compare-options__select--dropdown-right"
      value={selectedRightKey}
      onValueChange={onRightChange}
      noValidate>
      {rightOptions.map((opt) => (
        <ZinSelectOption
          key={opt.value}
          value={opt.value}>
          {opt.label}
        </ZinSelectOption>
      ))}
    </ZinSelect>
  </div>
)
